import { Preferences } from '@capacitor/preferences';
import { BF_PLEDGE_YEAR } from '@/constants/MyGiving/building-fund-pledge';

// "My Dreams & Prayers" on the BF2026 pledge pages (D23, F25): an optional
// write-in kept on this device only. It is never sent to any API — what a member
// writes here may be pastoral. Keyed by member and campaign year, so a device
// shared by two members never shows one member's words to the other.

export const dreamsKey = memberId => `bf-dreams-prayers:${BF_PLEDGE_YEAR}:${memberId}`;

/**
 * The member's saved text, `''` when they have saved none, or `null` when there
 * is no member yet (the profile has not loaded) — never a key built on
 * `undefined`, which every signed-out read would share.
 */
export async function loadDreams(memberId) {
  if (!memberId) return null;
  const { value } = await Preferences.get({ key: dreamsKey(memberId) });
  return value ?? '';
}

/** Saves the text, or removes the entry when it is blank. */
export async function saveDreams(memberId, text) {
  if (!memberId) throw new Error('No member to save Dreams & Prayers for');
  const key = dreamsKey(memberId);
  if (text) await Preferences.set({ key, value: text });
  else await Preferences.remove({ key });
}
